<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To Evie, Oliver and the rest of the Duckworth clan, your support means everything!</p>
<p>Special thanks to Dad for passing on your love of history and bringing Gereon to life.</p>
<p>Finally, I will be eternally grateful to Ryan for helping every step of the way.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?502defce